import { ExternalRegionLink } from '@acp/feature/auth';
import {
    Box, Divider, PopoverArrow, PopoverBody, Text, VStack,
} from '@chakra-ui/react';

export function PortfolioPopoverContent() {
    return (
        <>
            <PopoverArrow />
            <PopoverBody fontSize="sm">
                <VStack gap={2} align="start">
                    <Box mt={2}>
                        <Text fontWeight="bold">Portfolio</Text>
                        <Text color="muted.700">
                            All properties enrolled to receive one or more services
                            from Detector Inspector.
                        </Text>
                    </Box>

                    <Box mt={2}>
                        <Text fontWeight="bold">Compliant</Text>
                        <Text fontStyle="italic" color="muted.700">
                            * Compliant includes items currently marked as Pending Items.
                        </Text>
                        <Text color="muted.700">
                            All safety checks are up to date and there are no outstanding compliance
                            issues identified at the property.
                        </Text>
                    </Box>

                    <Box mt={2}>
                        <Text fontWeight="bold">Compliance issues</Text>
                        <Text color="muted.700">
                            Includes properties that have unresolved reported findings
                            with compliance issues that require further action.
                        </Text>
                    </Box>

                    <Box mt={2}>
                        <Text fontWeight="bold">Booking in progress</Text>
                        <Text color="muted.700">
                            Includes properties where services are past due but are
                            currently in the booking process.
                        </Text>
                    </Box>

                    <Divider mt={2} />
                    {/* Footnotes */}
                    <Box>
                        <Text color="muted.700">
                            * This view does not include&nbsp;
                            <Text
                                as={ExternalRegionLink}
                                path="/Quotations/index?status=Expired"
                            >
                                expired or rejected quotes.
                            </Text>
                        </Text>
                    </Box>
                </VStack>
            </PopoverBody>
        </>
    );
}
